export class Entreprise {
    static jsonMap = {
        id: { key: 'id', optional: true }
    };

    public id: number;
}
